
<div class="ttmodal" *ngIf="isMainCategoery">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Add Main Category</span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
    </div>
    <div class="ttmodal__body" >
        <div class="input-container flexInput" >
            <span class="label">Main Category Name <span class="red-text"></span></span>
            
            <input class="input-text" [(ngModel)]="maincategoryName" type="text" placeholder="Main Category Name" required>
        </div>
        <!-- <div class="input-container">
          <span class="label">Category Description <span class="red-text"></span></span>
          
          <input [(ngModel)]="categoryDesc" type="text" placeholder="Category Description" >
      </div> -->
    </div>
  
    <div class="ttmodal__footer" >
        <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" (click)="onAddMainCategory()"><span class="button__text">Add Main Category</span></a>
    </div>
  </div>

  <div class="ttmodal" *ngIf="isMainCategoeryEdit">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Edit Main Category</span>
       
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
    </div>
    <div class="ttmodal__body" >
        <div class="input-container flexInput">
            <span  class="label">Main Category Name <span class="red-text"></span></span>
            
           
  
            
            <input class="input-text" [(ngModel)]="Name" type="text" placeholder="Name" required>
        </div>
    </div>
  
    <div class="ttmodal__footer" >
        <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" (click)="onEditMiancategory()"><span class="button__text">Update</span></a>
    </div>
  </div>

<div class="ttmodal" *ngIf="isCategoery">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Add Category</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body" >
      <div class="input-container flexInput" >
          <span class="label">Category Name <span class="red-text"></span></span>
          
          <input class="input-text" [(ngModel)]="categoryName" type="text" placeholder="Category Name" required>
      </div>
      <!-- <div class="input-container">
        <span class="label">Category Description <span class="red-text"></span></span>
        
        <input [(ngModel)]="categoryDesc" type="text" placeholder="Category Description" >
    </div> -->
  </div>

  <div class="ttmodal__footer" >
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" (click)="onAddCategory()"><span class="button__text">Add Category</span></a>
  </div>
</div>


<div class="ttmodal" *ngIf="isCategoeryEdit">
  <div class="ttmodal__header">
      <span *ngIf="isParent" class="ttmodal__title">Edit Category</span>
      <span *ngIf="!isParent" class="ttmodal__title">Edit Sub Category</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body" >
      <div class="input-container flexInput">
          <span *ngIf="isParent" class="label">Category Name <span class="red-text"></span></span>
          
         

          <span *ngIf="!isParent" class="label">Sub Category Name <span class="red-text"></span></span>
          
          <input class="input-text" [(ngModel)]="Name" type="text" placeholder="Name" required>
      </div>
  </div>

  <div class="ttmodal__footer" >
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" (click)="onEditategory()"><span class="button__text">Update</span></a>
  </div>
</div>


<div class="ttmodal" *ngIf="isTrainingEdit">
  <div class="ttmodal__header">
      <span  class="ttmodal__title">Edit Training Name</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body" >
      <div class="input-container flexInput">
          <span  class="label">Training Name <span class="red-text"></span></span>
          
          <input class="input-text" [(ngModel)]="Name" type="text" placeholder="Name" required>
      </div>
  </div>

  <div class="ttmodal__footer" >
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" (click)="onEditTraining()"><span class="button__text">Update</span></a>
  </div>
</div>
<div class="ttmodal" *ngIf="isSection">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Add Sub Category</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body" >
      <div class="input-container flexInput">
          <span class="label">Sub Category Name <span class="red-text"></span></span>
          
          <input class="input-text" [(ngModel)]="sectionName" type="text" placeholder="Sub Category Name" required>
      </div>
  </div>

  <div class="ttmodal__footer" >
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" (click)="onAddSection()"><span class="button__text">Add Sub Category</span></a>
  </div>
</div>

<div class="ttmodal" *ngIf="isTraining">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Add Training </span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body" >
      <div class="input-container flexInput">
          <span class="label">Training Name <span class="red-text"></span></span>
          
          <input class="input-text" [(ngModel)]="trainingName" type="text" placeholder="Training Name" required>
      </div>
  </div>

  <div class="ttmodal__footer" >
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" (click)="onAddTraining()"><span class="button__text">Add Training</span></a>
  </div>
</div>

<div class="ttmodal" *ngIf="isTrainingSection">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Add Training Sub Section</span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
    </div>
    <div class="ttmodal__body" >
        <div class="input-container flexInput">
            <span class="label">Training Section Name <span class="red-text"></span></span>
            
            <input class="input-text" [(ngModel)]="trainingSectionName" type="text" placeholder="Training Section Name" required>
        </div>
    </div>
  
    <div class="ttmodal__footer" >
        <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" (click)="onAddTrainingSection()"><span class="button__text">Add Section</span></a>
    </div>
  </div>
  <div class="ttmodal" *ngIf="isSubTrainingEdit">
    <div class="ttmodal__header">
        <span  class="ttmodal__title">Edit Section Name</span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
    </div>
    <div class="ttmodal__body" >
        <div class="input-container flexInput">
            <span  class="label">Section Name <span class="red-text"></span></span>
            
            <input class="input-text" [(ngModel)]="Name" type="text" placeholder="Name" required>
        </div>
    </div>
  
    <div class="ttmodal__footer" >
        <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" (click)="onEditSubTraining()"><span class="button__text">Update</span></a>
    </div>
  </div>